import { Calendar, MapPin, Trophy, Ticket, Bell, BarChart2 } from "lucide-react";

export const GameInfoPanel = ({ broadcast, isNotStarted }) => {
  const formatGameTime = () => {
    if (!broadcast.scheduled_date) return "TBD";
    const date = new Date(`${broadcast.scheduled_date}T${broadcast.scheduled_time || "00:00"}`);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-zinc-900/50 border border-white/10 p-4">
      <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 flex items-center gap-2">
        <Calendar className="w-4 h-4 text-orange-500" />
        Game Info
      </h3>

      <div className="space-y-3">
        <div className="flex items-start gap-3">
          <Calendar className="w-4 h-4 text-zinc-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-zinc-500 text-xs uppercase">Date & Time</p>
            <p className="text-white text-sm">{formatGameTime()}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Trophy className="w-4 h-4 text-zinc-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-zinc-500 text-xs uppercase">Sport</p>
            <p className="text-white text-sm capitalize">{broadcast.sport || 'TBD'}</p>
          </div>
        </div>

        {broadcast.location && (
          <div className="flex items-start gap-3">
            <MapPin className="w-4 h-4 text-zinc-500 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-zinc-500 text-xs uppercase">Location</p>
              <p className="text-white text-sm">{broadcast.location}</p>
              {broadcast.location_image && (
                <div className="mt-2 rounded overflow-hidden">
                  <img
                    src={broadcast.location_image}
                    alt={broadcast.location}
                    className="w-full h-24 object-cover"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {broadcast.ticket_link && isNotStarted && (
        <a
          href={broadcast.ticket_link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full py-3 bg-green-600 hover:bg-green-700 text-white text-xs font-bold uppercase transition-colors flex items-center justify-center gap-2"
        >
          <Ticket className="w-4 h-4" />
          Get Tickets
        </a>
      )}

      {broadcast.stats_link && isNotStarted && (
        <div className="mt-3 p-3 bg-green-500/10 border border-green-500/30 rounded">
          <div className="flex items-center gap-2 text-green-500 text-xs">
            <BarChart2 className="w-4 h-4" />
            <span className="font-bold uppercase">Live Stats Ready</span>
          </div>
          <p className="text-zinc-400 text-[10px] mt-1">
            Box score and play-by-play will be available when the game starts
          </p>
        </div>
      )}

      {isNotStarted && (
        <button className="mt-3 w-full py-3 bg-orange-600 hover:bg-orange-700 text-white text-xs font-bold uppercase transition-colors flex items-center justify-center gap-2">
          <Bell className="w-4 h-4" />
          Remind Me
        </button>
      )}
    </div>
  );
};
